import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import { ReducerState } from '../../store.types';

export const fundAssetClassSelector = ({ fundAssetClass }: ReducerState) => fundAssetClass;
export const fundAssetClassLoadingSelector = createSelector(
  fundAssetClassSelector,
  ({ fetchStatus }) => fetchStatus === fetchStatuses.pending,
);
